import React from "react";
import PropTypes from "prop-types";
import { Menu, Dropdown } from "antd";
import { history } from "router";
import { CASE_UPGRADE_ACTIONS } from "constants";
import _capitalize from "lodash/capitalize";
// import PropTypes from "prop-types";
const onMenuClick = (
    case_ids,
    case_tasks_ids,
    stage_id,
    stage_name,
    { key }
) => {
    history.replace("/app/inbox", {
        case_actions: {
            action: key,
            case_id: case_ids,
            case_task_id: case_tasks_ids,
            stage_id,
            stage_name
        }
    });
};

const getMenu = (actions, case_ids, case_tasks_ids, stage_id, stage_name) => {
    return (
        <Menu
            className="nav-menu"
            onClick={onMenuClick.bind(
                null,
                case_ids,
                case_tasks_ids,
                stage_id,
                stage_name
            )}>
            {actions
                .toSeq()
                .map(_ => <Menu.Item key={_}>{_capitalize(_)}</Menu.Item>)
                .toList()
                .toArray()}
        </Menu>
    );
};

const CaseActionDropdownCreator = (
    actionPermissionMap,
    stageId,
    stageName,
    taskIds = null
) => {
    const permittedActions = CASE_UPGRADE_ACTIONS.toSeq()
        .filter(_ => actionPermissionMap.get(_))
        .toList();

    const firstAction = permittedActions.first();
    if (!firstAction) {
        return null;
    }

    const BulkCaseActionDropdown = ({
        data,
        selectedKeys,
        disabled,
        keyFilter
    }) => {
        const filteredData = data.filter(_ =>
            selectedKeys.includes(_[keyFilter])
        );
        const caseIds = filteredData.map(_ => _.id);
        const caseTaskIds = filteredData.map(_ => _.task_id);
        return (
            <Dropdown.Button
                type={"primary"}
                disabled={disabled}
                style={{ boxShadow: "none", marginLeft: "10px" }}
                overlay={getMenu(
                    permittedActions.rest(),
                    caseIds.toArray(),
                    taskIds || caseTaskIds.toArray(),
                    stageId,
                    stageName
                )}
                trigger={["hover"]}
                placement={"bottomRight"}
                onClick={onMenuClick.bind(
                    null,
                    caseIds.toArray(),
                    taskIds || caseTaskIds.toArray(),
                    stageId,
                    stageName,
                    {
                        key: firstAction
                    }
                )}>
                {_capitalize(firstAction)}
            </Dropdown.Button>
        );
    };
    BulkCaseActionDropdown.propTypes = {
        data: PropTypes.object,
        selectedKeys: PropTypes.object,
        disabled: PropTypes.bool,
        keyFilter: PropTypes.string
    };
    return BulkCaseActionDropdown;
};

export default CaseActionDropdownCreator;
